import "../../../assets/presentation/components/view-port/view-port-DDkeKlQt.css";
import { ViewPortBreakpoint } from "../../../domain/view-port/view-port-breakpoints.js";
import { BlockingView } from "../layout/blocking-view/blocking-view2.js";
import { useViewPort } from "../../hooks/use-view-port.js";
import { ScrollToHashElement } from "./scroll-to-hash-element.js";
/* empty css          */
import classNames from "classnames";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/presentation/components/view-port/view-port.tsx
var ViewPort = ({ children, className, isPending, loadingText, testId }) => {
	const { breakpoint } = useViewPort();
	return /* @__PURE__ */ jsxs(BlockingView, {
		className: classNames(className, "view-port", {
			smartphone: breakpoint === ViewPortBreakpoint.SMARTPHONE,
			tablet: breakpoint === ViewPortBreakpoint.TABLET,
			desktop: breakpoint === ViewPortBreakpoint.DESKTOP
		}),
		component: "div",
		isPending,
		loadingText,
		testId,
		children: [children, /* @__PURE__ */ jsx(ScrollToHashElement, {})]
	});
};
//#endregion
export { ViewPort };

//# sourceMappingURL=view-port2.js.map